// extracted by mini-css-extract-plugin
export default {"trialOptions":"TrialActivationModal_trialOptions__zBDrQ","bold":"TrialActivationModal_bold__yQr5S","textGray":"TrialActivationModal_textGray__X1HOL"};